module.exports = __webpack_public_path__ + "img/Speed.82a834c.svg";